import { render } from "./ServiceContentBox.component.vue?vue&type=template&id=09f4d3a8"
import script from "./ServiceContentBox.component.vue?vue&type=script&lang=js"
export * from "./ServiceContentBox.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/phoneBook/servicesContent/servicesContentComponents/ServiceContentBox.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "09f4d3a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('09f4d3a8', __exports__)) {
    console.log('reload')
    api.reload('09f4d3a8', __exports__)
  }
  
  module.hot.accept("./ServiceContentBox.component.vue?vue&type=template&id=09f4d3a8", () => {
    console.log('re-render')
    api.rerender('09f4d3a8', render)
  })

}


export default __exports__